import React, { useRef } from "react";
import {
  Modal,
  Text,
  TouchableOpacity,
  StyleSheet,
  Pressable,
} from "react-native";
import Cross from "@assets/svg/CrossIcon";
import { useNavigation } from "@react-navigation/native";
import { markTaskActions } from "@services/api";
import { getActions } from "../constants";

const CallOptionsModal = ({
  selectedMarker,
  visible,
  callModalMode,
  onClose,
  setShowCallOptionsModal,
  setContactOption,
  refreshData,
  taskActionConfig,
}: {
  selectedMarker: any;
  visible: boolean;
  callModalMode: string;
  onClose: () => void;
  setShowCallOptionsModal: (action: boolean) => void;
  setContactOption: (action: any) => void;
  refreshData: any;
  taskActionConfig: any;
}) => {
  const title =
    callModalMode === "EDIT"
      ? "कॉल का स्टेटस बदलें"
      : "कॉल का स्टेटस मार्क करे";
  const isMarking = useRef(false);
  const navigation = useNavigation();
  const isDMinusTwoOrder = selectedMarker?.any_pending_d_minus_2 || false;

  const markingAction = async (reason: string, action: string) => {
    try {
      if (!isMarking.current) {
        isMarking.current = true;
        const payload = {
          action,
          cx_id: selectedMarker?.user_id,
          status: "pending",
          reason,
          pending_order_ids:
            selectedMarker?.to_be_delivered_ids ||
            selectedMarker?.delivery_pending_order_ids ||
            [],
          is_d_minus_2: isDMinusTwoOrder,
        };
        if (
          payload.action &&
          payload.cx_id &&
          payload.status &&
          payload.reason
        ) {
          const response = await markTaskActions(payload);
          // Reschedule (incl. RESCHEDULE_AFTER_CALL) may be OTP-gated server-side.
          if (response?.data?.payload?.error === "OTP_VERIFICATION_FAILED") {
            const p = response.data.payload;
            navigation.navigate("RescheduleOTPVerification", {
              otpLength: p.otpLength,
              otpText: p.errorText,
              phone_numbers: p.phone_numbers || [],
              taskPayload: payload,
              popCount: 1,
            });
            return;
          }
        }
        isMarking.current = false;
        setShowCallOptionsModal(false);
        setContactOption(null);
        refreshData && refreshData();
      }
    } catch (err) {
      console.log(err);
    } finally {
      isMarking.current = false;
      setShowCallOptionsModal(false);
      setContactOption(null);
    }
  };

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      statusBarTranslucent
      navigationBarTranslucent
      onRequestClose={onClose}
    >
      <Pressable style={styles.overlay} onPress={onClose}>
        <Pressable
          style={styles.modalContainer}
          onStartShouldSetResponder={() => true}
        >
          <Pressable style={styles.modalClose} onPress={onClose}>
            <Cross />
          </Pressable>
          <Text style={styles.titleText}>{title}</Text>
          {getActions(callModalMode, Object.values(taskActionConfig)).map(
            (action) => {
              const disabled = action?.disable_on_d_minus_2 && isDMinusTwoOrder;
              return (
                <>
                  <TouchableOpacity
                    disabled={disabled}
                    style={[
                      styles.button,
                      {
                        backgroundColor: disabled
                          ? "rgba(241, 241, 241, 1)"
                          : "#fff",
                      },
                      selectedMarker?.action == action?.action
                        ? {
                            borderColor: "rgba(0, 171, 89, 1)",
                            backgroundColor: "rgba(242, 251, 247, 1)",
                          }
                        : {},
                    ]}
                    onPress={() => markingAction(action?.key, action?.action)}
                  >
                    <Text
                      style={[
                        styles.buttonText,
                        selectedMarker?.action == action?.action
                          ? { color: "rgba(0, 171, 89, 1)" }
                          : {},
                        disabled ? { color: "rgba(189, 189, 189, 1)" } : {},
                      ]}
                    >
                      {action?.value}
                    </Text>
                  </TouchableOpacity>
                  {disabled && action?.hint ? (
                    <Text style={styles.hint}>{action?.hint}</Text>
                  ) : null}
                </>
              );
            },
          )}
        </Pressable>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContainer: {
    paddingHorizontal: 16,
    paddingVertical: 24,
    backgroundColor: "#fff",
    borderRadius: 16,
    alignItems: "center",
  },
  modalClose: { position: "absolute", right: 10, top: 8 },
  titleText: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 15,
  },
  button: {
    width: "100%",
    paddingVertical: 8,
    marginTop: 12,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "#ddd",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 16,
  },
  buttonText: {
    fontSize: 16,
    textAlign: "center",
  },
  hint: {
    marginTop: 4,
    fontSize: 12,
    color: "red",
  },
});

export default CallOptionsModal;
